// extracted by mini-css-extract-plugin
export var root = "applications-landing-main-module--root--92ea6";